import * as Yup from "yup";

export const personalInformation = () => {
  return Yup.object().shape({
    givenName: Yup.string()
      .min(2, "Given name must be at least 2 characters")
      .required("Given name is required"),
    middleName: Yup.string()
      .min(2, "Middle name must be at least 2 characters")
      .notRequired()
      .nullable()
      .transform((value) => (value === "" ? null : value)),
    surname: Yup.string()
      .min(2, "Surname must be at least 2 characters")
      .required("Surname is required"),
    gender: Yup.string()
      .oneOf(["M", "F", "X"], "Please select a valid gender")
      .required("Gender is required"),
    streetAddressLine1: Yup.string().required("Street address is required"),
    streetAddressLine2: Yup.string().nullable(),
    locality: Yup.string().required("City is required"),
    province: Yup.string().required("Province is required"),
    postalCode: Yup.string()
      .matches(
        /^[A-Za-z]\d[A-Za-z] \d[A-Za-z]\d$/,
        "Invalid postal code format"
      )
      .required("Postal code is required"),
    country: Yup.string().required("Country is required"),
    email: Yup.string()
      .email("Please enter a valid email address")
      .required("Email address is required"),
    mobile: Yup.string()
      .matches(
        /^\(\d{3}\) \d{3}-\d{4}$/,
        "Enter a valid 10-digit Canadian number."
      )
      .nullable()
      .transform((value) => (value === "" ? null : value))
      .test(
        "one-of-required",
        "Must have either mobile or phone.",
        function () {
          // Check if both fields are null or empty strings
          let valid =
            !(this.parent.mobile === null || this.parent.mobile === "") ||
            !(this.parent.phone === null || this.parent.phone === "");
          return valid;
        }
      ),
    phone: Yup.string()
      .matches(
        /^\(\d{3}\) \d{3}-\d{4}$/,
        "Enter a valid 10-digit Canadian number."
      )
      .nullable()
      .transform((value) => (value === "" ? null : value))
      .test("one-of-required", "", function (value) {
        // Check if both fields are null or empty strings
        let valid =
          !(this.parent.mobile === null || this.parent.mobile === "") ||
          !(this.parent.phone === null || this.parent.phone === "");
        return valid;
      }),
  });
};
